interface Props {
    message: string;
    onClose: () => void;
}

/**
 * Shown when a Bingo claim is rejected (no winning pattern yet). Must be
 * explicitly dismissible -- the player keeps their cartelas and can keep
 * marking numbers, nothing about the game state changes on a false claim.
 */
export function NotAWinnerModal({ message, onClose }: Props) {
    return (
        <div className="w-result-overlay" role="dialog" aria-modal="true">
            <div className="w-notwin-card">
                <div className="w-notwin-icon">✕</div>
                <div className="w-notwin-title">Not a Winner Yet</div>
                <p className="w-notwin-message">{message}</p>
                <button type="button" className="w-play-again" onClick={onClose}>
                    Continue Playing
                </button>
            </div>
        </div>
    );
}
